export const CLIENT_ROUTE = '/version';
export const API_ROUTE = '/api/version';
export const CLIENT_TITLE = 'Апп хувилбар';